import qs from 'querystring';
import client from './rest/AdminClient';

export const getCarrierScoreMetric = function (id, filters) {
  return new Promise((resolve, reject) => {
    client({
      method: 'GET',
      path: `/api/metrics/${id}/score?${qs.stringify(filters)}`,
    }).then(
      (response) => {
        resolve(response.entity);
      },
      (response) => {
        reject(response.entity);
      },
    );
  });
};

export const getCarrierOnTimeMetric = function (id, filters) {
  return new Promise((resolve, reject) => {
    client({
      method: 'GET',
      path: `/api/metrics/${id}/on-time?${qs.stringify(filters)}`,
    }).then(
      (response) => {
        resolve(response.entity);
      },
      (response) => {
        reject(response.entity);
      },
    );
  });
};

export const getCarrierStopTimelinessMetric = function (id, filters) {
  return new Promise((resolve, reject) => {
    return client({
      method: 'GET',
      path: `/api/metrics/${id}/stop-completion-timeliness?${qs.stringify(
        filters,
      )}`,
    }).then(
      (response) => {
        resolve(response.entity);
      },
      (response) => {
        reject(response.entity);
      },
    );
  });
};

export const getCarrierPODTimelinessMetric = function (id, filters) {
  return new Promise((resolve, reject) => {
    return client({
      method: 'GET',
      path: `/api/metrics/${id}/pod-timeliness?${qs.stringify(filters)}`,
    }).then(
      (response) => {
        resolve(response.entity);
      },
      (response) => {
        reject(response.entity);
      },
    );
  });
};

export const getCarrierPODQualityMetric = function (id, filters) {
  return new Promise((resolve, reject) => {
    return client({
      method: 'GET',
      path: `/api/metrics/${id}/pod-quality?${qs.stringify(filters)}`,
    }).then(
      (response) => {
        resolve(response.entity);
      },
      (response) => {
        reject(response.entity);
      },
    );
  });
};

export const getCarrierCompletionRateMetric = function (id, filters) {
  return new Promise((resolve, reject) => {
    return client({
      method: 'GET',
      path: `/api/metrics/${id}/completion-rate?${qs.stringify(filters)}`,
    }).then(
      (response) => {
        resolve(response.entity);
      },
      (response) => {
        reject(response.entity);
      },
    );
  });
};

export const getCarrierAppUsageMetric = function (id, filters) {
  return new Promise((resolve, reject) => {
    return client({
      method: 'GET',
      path: `/api/metrics/${id}/app-usage?${qs.stringify(filters)}`,
    }).then(
      (response) => {
        resolve(response.entity);
      },
      (response) => {
        reject(response.entity);
      },
    );
  });
};

export const getDriverPerformanceMetrics = function (id, filters) {
  return new Promise((resolve, reject) => {
    return client({
      method: 'GET',
      path: `/api/metrics/${id}/performance?${qs.stringify(filters)}`,
    }).then(
      (response) => {
        resolve(response.entity);
      },
      (response) => {
        reject(response.entity);
      },
    );
  });
};
